<template lang="pug">
  .content
    .container
      template(v-if="promoIsActive")
        .content__title(v-html="frontendSettings.content_title")
        .content__desc(v-html="frontendSettings.content_description")
        .content__wrap
          Challenge(v-for="(el, i) in challengesList" :key="i" :data="el" :offersList="offersList" :frontendSettings="frontendSettings")
      Faq
</template>

<script>
import Challenge from "./Challenge";
import Faq from "./Faq";

export default {
  name: "PromoContent",
  components: {
    Challenge,
    Faq,
  },
  props: {
    promoIsActive: {
      type: Boolean,
      default: false,
    },
    frontendSettings: {
      type: Object,
      default: null,
    },
    challengesList: {
      type: Array,
      default: () => [],
    },
    offersList: {
      type: Object,
      default: null,
    },
  },
}
</script>